import React from 'react'
import { useField } from 'formik'
import { TextInputCustomFieldProps } from './interface'

export function withTextInputCustomField(
  Component: React.FC<TextInputCustomFieldProps>
) {
  function WithTextInputCustomField({
    name,
    ...props
  }: TextInputCustomFieldProps) {
    const [field, { touched, error }] = useField(name)

    const componentProps = {
      touched,
      error,
      ...props,
      ...field,
    }

    return <Component {...componentProps} />
  }

  return WithTextInputCustomField
}
